import React from 'react';
import PropTypes from 'prop-types';

import { Accent, Box, Text } from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';

import styles from './threeIconLayout.module.less';

const ThreeIconLayoutTile = ({ title, copy, image, imageAlt }) => {
  const copyInHTML = () => ({ __html: copy });

  const tileOutput = (
    <div className={styles.threeIconTile}>
      {image && (
        <Image
          src={image}
          alt={imageAlt}
          backgroundColor="transparent"
          naturalWidth={1000}
          naturalHeight={1000}
          className={styles.threeIconImage}
          lazy
        />
      )}
      <div className={styles.threeIconTitle}>
        <Accent>{title}</Accent>
      </div>
      <Text component="div">
        <div
          className={styles.threeIconCopy}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={copyInHTML()}
        />
      </Text>
    </div>
  );

  return <Box className={styles.threeIconBox}>{tileOutput}</Box>;
};

ThreeIconLayoutTile.propTypes = {
  title: PropTypes.string,
  copy: PropTypes.string,
  image: PropTypes.string,
  imageAlt: PropTypes.string,
};

ThreeIconLayoutTile.displayName = 'Three Icon Layout Tile';

export default ThreeIconLayoutTile;
